import { LogisticUnitSimpleTextProps } from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import { iPopupDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Popup/Popup';
import { addProps } from 'fulogics-ui-web/dist/layout/inspector/addProps';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { nameof } from 'ts-simple-nameof/src/nameof';
import { AllowedStacksHeaderProps } from '../../../templates/dataGrid/header/allowed-stacks-header-template/AllowedStacksHeader';

export const PayloadDetailsPopupReturnStepPayloadGridId =
    'PayloadDetailsPopup.ReturnStepPayloadGrid';
const PayloadDetailsPopupReturnStepPayloadGridOptions: iDataGridDisplayOptions = {
    id: PayloadDetailsPopupReturnStepPayloadGridId,
    columnAutoWidth: true,
    showBorders: false,
    width: '100%',
    height: '100%',
    columns: [
        {
            dataField: 'id',
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexColumn',
        },
        {
            dataField: 'product.sku',
            dataType: 'string',
            caption: 't~PayloadDetailsPopup:column.sku',
        },
        {
            dataField: 'product.name',
            dataType: 'string',
            caption: 't~PayloadDetailsPopup:column.productName',
        },
        {
            dataField: 'carrierTypeName',
            dataType: 'string',
            caption: 't~PayloadDetailsPopup:column.carriersType',
        },
        {
            dataField: 'maximumAllowedStacks',
            headerCellTemplate: 'AllowedStacksHeader',
            dataType: 'string',
            width: '120px',
        },
        {
            dataField: 'count',
            dataType: 'number',
            caption: 't~PayloadDetailsPopup:column.count',
            width: '80px',
        },
    ],
};
propsStore.insert(PayloadDetailsPopupReturnStepPayloadGridOptions);

export const PayloadDetailsPopupForwardStepPayloadGridId =
    'PayloadDetailsPopup.ForwardStepPayloadGrid';
const PayloadDetailsPopupForwardStepPayloadGridOptions: iDataGridDisplayOptions = {
    id: PayloadDetailsPopupForwardStepPayloadGridId,
    columnAutoWidth: true,
    showBorders: false,
    width: '100%',
    height: '100%',
    columns: [
        {
            dataField: 'id',
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexColumn',
        },
        {
            dataField: 'sku',
            caption: 't~PayloadDetailsPopup:column.sku',
            width: '30%',
        },
        {
            dataField: 'name',
            caption: 't~PayloadDetailsPopup:column.productName',
            width: '70%',
        },
        {
            dataField: 'productsQuantity',
            caption: 't~PayloadDetailsPopup:column.productsQuantity',
            width: '120px',
        },
        {
            headerCellTemplate: 'AllowedStacksHeader',
            dataField: 'carriersQuantity',
            cellTemplate: 'PayloadCarrierCountSimpleText',
            width: '120px',
        },
    ],
};
propsStore.insert(PayloadDetailsPopupForwardStepPayloadGridOptions);

export const PayloadDetailsPopupAllowedStacksHeaderId =
    'PayloadDetailsPopup.ForwardStepPayloadGrid.column.carriersQuantity';
const PayloadDetailsPopupAllowedStacksHeaderOptions: AllowedStacksHeaderProps = {
    id: PayloadDetailsPopupAllowedStacksHeaderId,
    title: 't~PayloadDetailsPopup:column.carriersQuantity',
};
propsStore.insert(PayloadDetailsPopupAllowedStacksHeaderOptions);

export const PayloadDetailsPopupAvigationPointId = 'PayloadDetailsPopup.AvigationPoint';
const PayloadDetailsPopupAvigationPointOptions: LogisticUnitSimpleTextProps & {
    id: string;
} = {
    id: PayloadDetailsPopupAvigationPointId,
    hideContactButton: true,
};
propsStore.insert(PayloadDetailsPopupAvigationPointOptions);

export const PayloadDetailsPopupId = 'PayloadDetailsPopup.Popup';
const PayloadDetailsPopupOptions: iPopupDisplayOptions = {
    id: PayloadDetailsPopupId,
    dragEnabled: false,
    closeOnOutsideClick: true,
    showCloseButton: true,
    height: '80%',
    maxWidth: '900px',
    showTitle: true,
};
propsStore.insert(PayloadDetailsPopupOptions);
